import React from 'react';
import { createBrowserRouter, Navigate, RouteObject, RouterProvider } from 'react-router';
import { lazy, Suspense } from 'react';
import { LinkPagesEnum } from 'app/store/enums/linkPages';
import { Loader } from 'shared/ui/Loader';
import { InformationPage } from './Information';
import { BillType } from 'enums/billType';
import { trackImport } from 'app/utils/trackImport';
import { GlobalLoadingIndicator } from 'shared/ui/GlobalLoadingIndicator';
// import { TestLoadingState } from 'shared/ui/TestLoadingState';



// TODO: думаю в будущем может быть проблема если мы захотиим делать preInit/preImport chunks
// так как наверное сработает этот трекер и юзеру будет показываться загрузка даже если он не ничего не делал
// а может и нет, надо будет провеить или как вариант там если в преинит методе не ставить трекер на импорт чанка как тут
// то и не будет проблем
// Convert all imports to lazy imports with named exports using trackImport
const RegistrationPage = lazy(() => trackImport(() => import('./Registration/ui').then(module => ({ default: module.RegistrationPage }))));
const AuthorizationPage = lazy(() => trackImport(() => import('./Authorization/ui').then(module => ({ default: module.AuthorizationPage }))));
const HomePage = lazy(() => trackImport(() => import('./Home/ui').then(module => ({ default: module.HomePage }))));
const AcceptanceBillsPage = lazy(() => trackImport(() => import('./AcceptanceBills/ui').then(module => ({ default: module.AcceptanceBillsPage }))));
// const AddingAcceptanceBillPage = lazy(() => import('./AddingAcceptanceBill/ui').then(module => ({ default: module.AddingAcceptanceBillPage })));
const ProductsPage = lazy(() => trackImport(() => import('./Products/ui').then(module => ({ default: module.ProductsPage }))));
const InventoryPage = lazy(() => trackImport(() => import('./Inventory/ui').then(module => ({ default: module.InventoryPage }))));
const CellsPage = lazy(() => trackImport(() => import('./Cells/ui').then(module => ({ default: module.CellsPage }))));
const TerminalPage = lazy(() => trackImport(() => import('./Terminal/ui/Terminal').then(module => ({ default: module.TerminalPage }))));
const PreProcessPage = lazy(() => trackImport(() => import('./Inspection/ui').then(module => ({ default: module.PreProcessPage }))));
const ShipmentBillsPage = lazy(() => trackImport(() => import('./ShipmentBills').then(module => ({ default: module.ShipmentBillsPage }))));
const SettingsPage = lazy(() => trackImport(() => import('./Settings/ui/Settings').then(module => ({ default: module.SettingsPage }))));
const UserProfilePage = lazy(() => trackImport(() => import('./Profile').then(module => ({ default: module.UserProfilePage }))));
// const PlacementProcessPage = lazy(() => import('./Placement/pages/Process').then(module => ({ default: module.PlacementProcessPage })));
const ShipmentBillPage = lazy(() => trackImport(() => import('./ShipmentBill').then(module => ({ default: module.ShipmentBillPage }))));
// const RedactShipmentBillPage = lazy(() => import('./RedactShipmentBill/ui').then(module => ({ default: module.RedactShipmentBillPage })));
const EmployeesPage = lazy(() => trackImport(() => import('./Employees').then(module => ({ default: module.EmployeesPage }))));
const UsersPage = lazy(() => trackImport(() => import('./Users').then(module => ({ default: module.UsersPage }))));
const SoonPage = lazy(() => trackImport(() => import('./Soon').then(module => ({ default: module.SoonPage }))));
// const InformationPage = lazy(() => import('./Information').then(module => ({ default: module.InformationPage })));
const ProcessesPage = lazy(() => trackImport(() => import('./Processes/ui').then(module => ({ default: module.ProcessesPage }))));
// const ShipProcessPage = lazy(() => import('./Ship/pages/Process').then(module => ({ default: module.ShipProcessPage })));
const InspectionProcessPage = lazy(() => trackImport(() => import('./Inspection/pages/Process').then(module => ({ default: module.InspectionProcessPage }))));
const WarehousesPage = lazy(() => trackImport(() => import('./Warehouses').then(module => ({ default: module.WarehousesPage }))));
const WarehousePage = lazy(() => trackImport(() => import('./Warehouse').then(module => ({ default: module.WarehousePage }))));
const PriceManagementPage = lazy(() => trackImport(() => import('./PriceManagement').then(module => ({ default: module.PriceManagementPage }))));
const UserTypeSelectPage = lazy(() => trackImport(() => import('./UserTypeSelect').then(module => ({ default: module.UserTypeSelectPage }))));
const WarehouseSchemePage = lazy(() => trackImport(() => import('./WarehouseScheme').then(module => ({ default: module.WarehouseSchemePage }))));
const WarehouseDesignerPage = lazy(() => trackImport(() => import('./WarehouseDesigner').then(module => ({ default: module.WarehouseDesignerPage }))));
const SupportPage = lazy(() => trackImport(() => import('./Support').then(module => ({ default: module.SupportPage }))));
const UpdateWarehousePage = lazy(() => trackImport(() => import('./UpdateWarehouse').then(module => ({ default: module.UpdateWarehousePage }))));
const InformationBasePage = lazy(() => trackImport(() => import('./InformationBase').then(module => ({ default: module.InformationBasePage }))));
const PlacementBillPage = lazy(() => trackImport(() => import('./PlacementBill').then(module => ({ default: module.PlacementBillPage }))));
const CalendarPage = lazy(() => trackImport(() => import('./Calendar').then(module => ({ default: module.CalendarPage }))));
const ChartsPage = lazy(() => trackImport(() => import('./Charts').then(module => ({ default: module.ChartsPage }))));
const IntegrationsPage = lazy(() => trackImport(() => import('./Integrations').then(module => ({ default: module.IntegrationsPage }))));
const ConsumablesPage = lazy(() => trackImport(() => import('./Consumables').then(module => ({ default: module.ConsumablesPage }))));
const ContainersPage = lazy(() => trackImport(() => import('./Containers').then(module => ({ default: module.default }))));
const OrganizationsPage = lazy(() => trackImport(() => import('./Organizations').then(module => ({ default: module.OrganizationsPage }))));
const CooperationsPage = lazy(() => trackImport(() => import('./Cooperations').then(module => ({ default: module.CooperationsPage }))));
const PlacementBillsPage = lazy(() => trackImport(() => import('./PlacementBills').then(module => ({ default: module.PlacementBillsPage }))));
const PackageBillsPage = lazy(() => trackImport(() => import('./PackageBills').then(module => ({ default: module.PackageBillsPage }))));
const PackageBillPage = lazy(() => trackImport(() => import('./PackageBill').then(module => ({ default: module.PackageBillPage }))));
const AddingKitPage = lazy(() => trackImport(() => import('./AddingKit').then(module => ({ default: module.AddingKitPage }))));
const PaymentBillPage = lazy(() => trackImport(() => import('./PaymentBill').then(module => ({ default: module.PaymentBillPage }))));
const PaymentBillsPage = lazy(() => trackImport(() => import('./PaymentBills').then(module => ({ default: module.PaymentBillsPage }))));
const SupportChatPage = lazy(() => trackImport(() => import('./Support/Chat').then(module => ({ default: module.SupportChatPage }))));
// const PackageProcessPage = lazy(() => import('./Package/pages/Process').then(module => ({ default: module.PackageProcessPage })));
const AcceptanceBillPage = lazy(() => trackImport(() => import('./AcceptanceBill/ui').then(module => ({ default: module.AcceptanceBillPage }))));
// const RedactAcceptanceBillPage = lazy(() => import('./RedactAcceptanceBill/ui').then(module => ({ default: module.RedactAcceptanceBillPage })));
const WarehouseRatingPage = lazy(() => trackImport(() => import('./WarehouseRating').then(module => ({ default: module.WarehouseRatingPage }))));
const CreateTicketPage = lazy(() => trackImport(() => import('./CreateTicket').then(module => ({ default: module.CreateTicketPage }))));
const ProductFormPage = lazy(() => trackImport(() => import('./ProductForm').then(module => ({ default: module.ProductFormPage }))));
const WorkShedulesPage = lazy(() => trackImport(() => import('./WorkShedules').then(module => ({ default: module.WorkShedulesPage }))));

// Import the imports pages
const DocumentsPage = lazy(() => trackImport(() => import('./Documents/ui').then(module => ({ default: module.DocumentsPage }))));
const NewImport = lazy(() => trackImport(() => import('./Documents/pages/NewImport').then(module => ({ default: module.NewImport }))));
const TemplatesPage = lazy(() => trackImport(() => import('./Documents/pages/Templates').then(module => ({ default: module.TemplatesPage }))));
const TemplateViewer = lazy(() => trackImport(() => import('./TemplateViewer').then(module => ({ default: module.TemplateViewer }))));

// Import Policy and Oferta pages
const PolicyPage = lazy(() => trackImport(() => import('./Policy').then(module => ({ default: module.PolicyPage }))));
const OfertaPage = lazy(() => trackImport(() => import('./Oferta').then(module => ({ default: module.OfertaPage }))));

type RouteType = {
  pageName: string;
  routeObject: RouteObject
};

// Create a wrapper component for Suspense
const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Suspense fallback={<Loader/>}>
      {children}
    </Suspense>
  );
};

export const routes: RouteType[] = [
  {
    pageName: "Документы",
    routeObject: {
      path: LinkPagesEnum.Documents,
      element: <SuspenseWrapper><DocumentsPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Новый импорт",
    routeObject: {
      path: LinkPagesEnum.ImportsNew,
      element: <SuspenseWrapper><NewImport /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Шаблон импорта",
    routeObject: {
      path: LinkPagesEnum.ImportsTemplate,
      element: <SuspenseWrapper><TemplateViewer /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Шаблоны",
    routeObject: {
      path: LinkPagesEnum.Templates,
      element: <SuspenseWrapper><TemplatesPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Управление ценами",
    routeObject: {
      path: LinkPagesEnum.PriceManagement,
      element: <SuspenseWrapper><PriceManagementPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Склад",
    routeObject: {
      path: LinkPagesEnum.Warehouse,
      element: <SuspenseWrapper><WarehousePage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Склады",
    routeObject: {
      path: LinkPagesEnum.Warehouses,
      element: <SuspenseWrapper><WarehousesPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Чат",
    routeObject: {
      path: LinkPagesEnum.SupportChat,
      element: <SuspenseWrapper><SupportChatPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Выбор типа аккаунта",
    routeObject: {
      path: LinkPagesEnum.UserTypeSelect,
      element: <SuspenseWrapper><UserTypeSelectPage/></SuspenseWrapper>,
    }
  },
  
  {
    pageName: "Накладная на упаковку",
    routeObject: {
      path: LinkPagesEnum.RedactPackageBill,
      element: <SuspenseWrapper><PackageBillPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "",
    routeObject: {
      path: "*",
      element: <Navigate to={LinkPagesEnum.Home}  replace/>,
    }
  },
  {
    pageName: "Склад",
    routeObject: {
      path: LinkPagesEnum.WarehouseScheme,
      element: <SuspenseWrapper><WarehouseSchemePage/></SuspenseWrapper>,
    }
  },
  {
    pageName: "Конструктор",
    routeObject: {
      path: LinkPagesEnum.WarehouseDesigner,
      element: <SuspenseWrapper><WarehouseDesignerPage/></SuspenseWrapper>,
    }
  },
  {
    pageName: "Поддержка",
    routeObject: {
      path: LinkPagesEnum.Support,
      element: <SuspenseWrapper><SupportPage/></SuspenseWrapper>,
    }
  },
  {
    pageName: "Создание склада",
    routeObject: {
      path: LinkPagesEnum.AddingWarehouse,
      element: <SuspenseWrapper><UpdateWarehousePage/></SuspenseWrapper>,
    }
  },
  {
    pageName: "Редактирование склада",
    routeObject: {
      path: LinkPagesEnum.RedactWarehouse,
      element: <SuspenseWrapper><UpdateWarehousePage/></SuspenseWrapper>,
    }
  },
  {
    pageName: "База информации",
    routeObject: {
      path: LinkPagesEnum.InformationBase,
      element: <SuspenseWrapper><InformationBasePage/></SuspenseWrapper>,
    }
  },
  {
    pageName: "Редактирование товара",
    routeObject: {
      path: LinkPagesEnum.RedactProduct,
      element: <SuspenseWrapper><ProductFormPage/></SuspenseWrapper>,
    }
  },
  {
    pageName: "Создание товара",
    routeObject: {
      path: LinkPagesEnum.AddingProduct,
      element: <SuspenseWrapper><ProductFormPage/></SuspenseWrapper>,
    }
  },
  {
    pageName: "Накладная на перемещение",
    routeObject: {
      path: LinkPagesEnum.RedactPlacementBill,
      element: <SuspenseWrapper><PlacementBillPage/></SuspenseWrapper>,
    }
  },
  {
    pageName: "Календарь",
    routeObject: {
      path: LinkPagesEnum.Calender,
      element: <SuspenseWrapper><CalendarPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Аналитика",
    routeObject: {
      path: LinkPagesEnum.Analytics,
      element: <SuspenseWrapper><ChartsPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Интеграции",
    routeObject: {
      path: LinkPagesEnum.Integrations,
      element: <SuspenseWrapper><IntegrationsPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Расходники",
    routeObject: {
      path: LinkPagesEnum.Consumables,
      element: <SuspenseWrapper><ConsumablesPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Организации",
    routeObject: {
      path: LinkPagesEnum.Organizations,
      element: <SuspenseWrapper><OrganizationsPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Сотрудничество",
    routeObject: {
      path: LinkPagesEnum.Cooperations,
      element: <SuspenseWrapper><CooperationsPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Транзитные накладные",
    routeObject: {
      path: LinkPagesEnum.PlacementBills,
      element: <SuspenseWrapper><PlacementBillsPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Создание накладной перемещения",
    routeObject: {
      path: LinkPagesEnum.AddingPlacementBill,
      element: <SuspenseWrapper><PlacementBillPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Упаковочные накладные",
    routeObject: {
      path: LinkPagesEnum.PackageBills,
      element: <SuspenseWrapper><PackageBillsPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Создание накладной упаковки",
    routeObject: {
      path: LinkPagesEnum.AddingPackageBill,
      element: <SuspenseWrapper><PackageBillPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Создание комплекта",
    routeObject: {
      path: LinkPagesEnum.AddingKit,
      element: <SuspenseWrapper><AddingKitPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Счет",
    routeObject: {
      path: LinkPagesEnum.PaymentBill,
      element: <SuspenseWrapper><PaymentBillPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Счета",
    routeObject: {
      path: LinkPagesEnum.PaymentBills,
      element: <SuspenseWrapper><PaymentBillsPage /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Процесс отгрузки",
    routeObject: {
      path: LinkPagesEnum.ShipProcess,
      element: <SuspenseWrapper><InspectionProcessPage processType={BillType.Shipment} /></SuspenseWrapper>,
    }
  },
  {
    pageName: "Процесс приёмки",
    routeObject: {
      path: LinkPagesEnum.InspectionProcess,
      element: <SuspenseWrapper><InspectionProcessPage processType={BillType.Acceptance} /></SuspenseWrapper>,
    }
  },
  {
      pageName: "Регистрация",
      routeObject: {
        path: LinkPagesEnum.Registration,
        element: <SuspenseWrapper><RegistrationPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Информация",
      routeObject: {
        path: LinkPagesEnum.Information,
        element: <InformationPage />,
      }
    },
    {
      pageName: "Авторизация",
      routeObject: {
        path: LinkPagesEnum.Authorization,
        element: <SuspenseWrapper><AuthorizationPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Профиль",
      routeObject: {
        path: LinkPagesEnum.UserProfile,
        element:<SuspenseWrapper><UserProfilePage/></SuspenseWrapper>
      }
    },
    {
      pageName: "Главная",
      routeObject: {
        path: LinkPagesEnum.Home,
        element: <SuspenseWrapper><HomePage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Создание процесса отгрузки",
      routeObject: {
        path: LinkPagesEnum.Ship,
        element: <SuspenseWrapper><PreProcessPage processType={BillType.Shipment} /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Накладные на приход",
      routeObject: {
        path: LinkPagesEnum.AcceptanceBills,
        element: <SuspenseWrapper><AcceptanceBillsPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Накладные на отгрузку",
      routeObject: {
        path: LinkPagesEnum.ShipmentBills,
        element: <SuspenseWrapper><ShipmentBillsPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Накладная на отгрузку",
      routeObject: {
        path: LinkPagesEnum.AddingShipmentBill,
        element: <SuspenseWrapper><ShipmentBillPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Накладная на отгрузку",
      routeObject: {
        path: LinkPagesEnum.RedactShipmentBill,
        element: <SuspenseWrapper><ShipmentBillPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Накладная на приход",
      routeObject: {
        path: LinkPagesEnum.RedactAcceptanceBill,
        element: <SuspenseWrapper><AcceptanceBillPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Накладная на приход",
      routeObject: {
        path: LinkPagesEnum.AddingAcceptanceBill,
        element: <SuspenseWrapper><AcceptanceBillPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Товары",
      routeObject: {
        path: LinkPagesEnum.Products,
        element: <SuspenseWrapper><ProductsPage /></SuspenseWrapper>
      }
    },
    {
      pageName: "Инветаризация",
      routeObject: {
        path: LinkPagesEnum.Inventory,
        element: <SuspenseWrapper><InventoryPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Ячейки",
      routeObject: {
        path: LinkPagesEnum.Cells,
        element: <SuspenseWrapper><CellsPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Дашбоард",
      routeObject: {
        path: LinkPagesEnum.Terminal,
        element: <SuspenseWrapper><TerminalPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Приёмка",
      routeObject: {
        path: LinkPagesEnum.Inspection,
        element: <SuspenseWrapper><PreProcessPage processType={BillType.Acceptance} /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Настройки",
      routeObject: {
        path: LinkPagesEnum.Settings,
        element: <SuspenseWrapper><SettingsPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Перемещение",
      routeObject: {
        path: LinkPagesEnum.PlacementProcess,
        element: <SuspenseWrapper><InspectionProcessPage processType={BillType.Placement} /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Создание процесса перемещения",
      routeObject: {
        path: LinkPagesEnum.Placement,
        element: <SuspenseWrapper><PreProcessPage processType={BillType.Placement} /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Создание процесса упаковки",
      routeObject: {
        path: LinkPagesEnum.Package,
        element: <SuspenseWrapper><PreProcessPage processType={BillType.Package} /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Упаковка",
      routeObject: {
        path: LinkPagesEnum.PackageProcess,
        element: <SuspenseWrapper><InspectionProcessPage processType={BillType.Package} /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Сотрудники",
      routeObject: {
        path: LinkPagesEnum.Employees,
        element: <SuspenseWrapper><EmployeesPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Пользователи",
      routeObject: {
        path: LinkPagesEnum.Users,
        element: <SuspenseWrapper><UsersPage/></SuspenseWrapper>,
      }
    },
    {
      pageName: "Скоро",
      routeObject: {
        path: LinkPagesEnum.Soon,
        element: <SuspenseWrapper><SoonPage/></SuspenseWrapper>,
      }
    },
    {
      pageName: "График сотрудников",
      routeObject: {
        path: LinkPagesEnum.EmployeesSchedule,
        element: <SuspenseWrapper><SoonPage/></SuspenseWrapper>,
      }
    },
    {
      pageName: "Оплата сотрудников",
      routeObject: {
        path: LinkPagesEnum.EmployeesPayment,
        element: <SuspenseWrapper><SoonPage/></SuspenseWrapper>,
      }
    },
    {
      pageName: "Транспортные компании",
      routeObject: {
        path: LinkPagesEnum.TransportCompanies,
        element: <SuspenseWrapper><SoonPage/></SuspenseWrapper>,
      }
    },
    {
      pageName: "Системы учета",
      routeObject: {
        path: LinkPagesEnum.AccountingSystems,
        element: <SuspenseWrapper><SoonPage/></SuspenseWrapper>,
      }
    },
    {
      pageName: "Процессы",
      routeObject: {
        path: LinkPagesEnum.Processes,
        element: <SuspenseWrapper><ProcessesPage/></SuspenseWrapper>,
      }
    },
    {
      pageName: "Рейтинг складов",
      routeObject: {
        path: LinkPagesEnum.WarehouseRating,
        element: <SuspenseWrapper><WarehouseRatingPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Создание заявки",
      routeObject: {
        path: LinkPagesEnum.CreateTicket,
        element: <SuspenseWrapper><CreateTicketPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Контейнеры",
      routeObject: {
        path: LinkPagesEnum.Containers,
        element: <SuspenseWrapper><ContainersPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "График сотрудников",
      routeObject: {
        path: LinkPagesEnum.WorkShedules,
        element: <SuspenseWrapper><WorkShedulesPage/></SuspenseWrapper>,
      }
    },
    {
      pageName: "Политика",
      routeObject: {
        path: LinkPagesEnum.Policy,
        element: <SuspenseWrapper><PolicyPage /></SuspenseWrapper>,
      }
    },
    {
      pageName: "Оферта",
      routeObject: {
        path: LinkPagesEnum.Oferta,
        element: <SuspenseWrapper><OfertaPage /></SuspenseWrapper>,
      }
    }
];

// Router component
const RouterComponent = () => {
  const routesConfig = routes.map(el => el.routeObject);
  const router = createBrowserRouter(routesConfig);
  
  return (
    <RouterProvider
      router={router} 
    />
  );
};

const Pages = () => {
  return (
    <>
      <GlobalLoadingIndicator />
      {/* <TestLoadingState /> */}
      <RouterComponent />
    </>
  );
};

export default Pages; 